/** 
  All of the routes for the Soft UI Dashboard PRO React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/
import Icon from "@mui/material/Icon";
import FixtuesList from "views/sportsbook";

// react-router components

// Soft UI Dashboard PRO React context


let dynamicRoutes = {};
let sportsDataApi = [];

let providerButtonClassPrototype = [
  {
    ".MuiButton-contained.provider-button-slug": {
      borderColor: "color !important",
      backgroundColor: "color !important",
    },
  },
  {
    ".MuiButton-contained.provider-button-slug:hover": {
      borderColor: "",
      backgroundColor: "color30 !important",
    },
  },
  {
    ".MuiButton-outlined.provider-button-slug:hover": {
      borderColor: "color !important",
      backgroundColor: "color30 !important",
    },
  },
  {
    ".MuiButton-outlined.provider-button-slug:disabled": {
      borderColor: "color !important",
      backgroundColor: "color30 !important",
    },
  },
];

class Utils {
  static createRoute(data, type) {
    let routeInstance;

    switch (type) {
      case "pregame":
        routeInstance = this.createRouteSportsBook(data, "pregame");
        break;
      case "inplay":
        routeInstance = this.createRouteSportsBook(data, "inplay");
        break;
      default:
        break;
    }

    return routeInstance;
  }

  static createRouteSportsBook(data, eventsType) {
    let routes = [];
    for (const key in data) {
      if (Object.hasOwnProperty.call(data, key)) {
        const sport = data[key];
        if (!sport.name) continue;
        let routeInstance = {
          name: sport.name + " (" + sport[eventsType] + "/" + sport[eventsType + "All"] + ")",
          key: sport.name,
          route: `/monitoring/${eventsType}/${sport.name.replace(/ /g, "_").toLowerCase()}`, //`/monitoring/${eventsType}/${sport.id}`,
          visible: true,
          permission: true,
          icon: <Icon>sports_{sport.name.replace(" ", "").toLowerCase()}_outlined_icon</Icon>,
          component: <FixtuesList sportId={sport.id} filterTemplateId={0} />,
        };
        routes.push(routeInstance);

        let routeInstance2 = {
          name: sport.name + " (" + sport[eventsType] + "/" + sport[eventsType + "All"] + ")",
          key: sport.name,
          route: `/monitoring/${eventsType}/${sport.name.replace(/ /g, "_").toLowerCase()}#:id`, //`/monitoring/${eventsType}/${sport.id}`,
          visible: false,
          permission: true,
          icon: <Icon>sports_{sport.name.replace(" ", "").toLowerCase()}_outlined_icon</Icon>,
          component: <FixtuesList sportId={sport.id} filterTemplateId={0} />,
        };

        routes.push(routeInstance2);
      }
    }

    return routes;
  }

  static getSportsApiData() {
    this.sportsDataApi = sportsDataApi;
    return this.sportsDataApi;
  }

  static apiCall() {
    let result;

    function createData(
      id: number,
      name: string,
      inplay: number,
      pregame: number,
      inplayAll: number,
      pregameAll: number
    ) {
      return { id, name, inplay, pregame, inplayAll, pregameAll };
    }

    let sportsApi = this.getSportsApiData();
    let sports = [];
    for (let index = 0; index < sportsApi.length; index++) {
      const sport = sportsApi[index];
      sports.push(
        createData(
          sport.id,
          sport.name,
          sport.inplay,
          sport.pregame,
          sport.inplayAll,
          sport.pregameAll
        )
      );
    }

    result = sports;
    return result;
  }

  static collectDynamicRoutes(route, hash, pathname, sports_numbers) {
    //const { hash, pathname } = useLocation();
    // if (lastLocation === pathname && filterTemplateId === hash) {
    //   if (dynamicRoutes[route]) {
    //     return dynamicRoutes[route];
    //   }
    // }
    // if (lastLocation != pathname) lastLocation = pathname;

    let collapse = [];

    if (!sports_numbers) sports_numbers = [];

    let sports = [...sports_numbers];

    let sums = sports.length > 0 ? sports.pop() : [];

    let apiResults = sports;
    let name = "";
    let icon = <Icon></Icon>;

    switch (route) {
      case "/monitoring/pregame/:sport":
        //apiResults = this.apiCall();
        collapse = apiResults.length == 0 ? collapse : this.createRoute(apiResults, "pregame");
        name = apiResults.length == 0 ? "(0/0)" : "(" + sums.pregame + "/" + sums.pregameAll + ")"; //" " + Math.random() * 1235 + "/" + Math.random() * 2537;
        icon = <Icon>today_outlined_icon</Icon>;
        break;

      case "/monitoring/inplay/:sport":
        //apiResults = this.apiCall();
        collapse = apiResults.length == 0 ? collapse : this.createRoute(apiResults, "inplay");
        name = apiResults.length == 0 ? "(0/0)" : "(" + sums.inplay + "/" + sums.inplayAll + ")"; //" " + Math.random() * 376 + "/" + Math.random() * 593;
        icon = <Icon>slow_motion_video_icon</Icon>;
        break;
      default:
        break;
    }
    dynamicRoutes[route] = { name: name, collapse: collapse, icon: icon };
    return { name: name, collapse: collapse, icon: icon };
  }

  static createCssProvidersColors(css, provider) {
    css[provider.name] = provider.color + " !important";
    css[provider.name + "-trans"] = provider.color + "00 !important";
    css[provider.name + "-hover"] = provider.color + "40 !important";
    css[provider.name + "-focus"] = provider.color + " !important";
    css[provider.name + "-disabled"] = provider.color + "10 !important";
    css[provider.name + "-icon"] = provider.color + "60 !important";
    css[provider.name + "-icon-text"] = "#ffffff !important";
    css[provider.name + "-slider-start"] = provider.color + "10 !important";
    css[provider.name + "-slider-end"] = provider.color + "10 !important";
    css[provider.name + "-gradient"] = { main: provider.color, state: provider.color + "10" };
  }

  static createCssProvidersButtons(css, provider) {
    for (let index = 0; index < providerButtonClassPrototype.length; index++) {
      const button = { ...providerButtonClassPrototype[index] };
      let cssRule = Object.keys(button)[0].toString().replace("slug", provider.name);
      let borderColor = Object.values(button)[0]
        ["borderColor"].toString()
        .replace("color", provider.color);
      let backgroundColor = Object.values(button)[0]
        ["backgroundColor"].toString()
        .replace("color", provider.color);

      css[cssRule] = {
        borderColor: borderColor + " !important",
        backgroundColor: backgroundColor + " !important",
      };
    }
  }
}

export default Utils;
